import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative bg-dark-black py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img src="/images/erik-mclean-C3T8KTZxTFM-unsplash.webp" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-toxic-orange/30 via-transparent to-transparent"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" itemProp="headline">
            Find Your Perfect Casino Match
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed" itemProp="description">
            We've done the research so you don't have to. Get matched with exclusive bonuses, trusted operators, and games that pay out.
          </p>
          <div className="flex flex-wrap gap-3 mb-8">
            <a
              href="#offers"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('offers')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-toxic-orange text-dark-black px-6 py-3 rounded-lg font-semibold hover:bg-orange-500 transition-colors"
            >
              Offers
            </a>
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors border border-gray-700"
            >
              About
            </a>
            <a
              href="#guides"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('guides')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors border border-gray-700"
            >
              Guides
            </a>
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors border border-gray-700"
            >
              FAQ
            </a>
            <a
              href="#news"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('news')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors border border-gray-700"
            >
              News
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gray-800 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors border border-gray-700"
            >
              Contact
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-dark-black to-transparent"></div>
    </section>
  );
};

export default Hero;

